import styled from 'styled-components';

export const NonprofitWrappers = styled.div`
    background: #FFFFFF 0% 0% no-repeat padding-box;
    border: 1px solid #000000;
    border-radius: 15px;
    padding: 22px 20px;
`;

export const NonprofitTitle = styled.h3`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:20px;
    font-weight: 700;
    line-height: 30px;
    margin-bottom: 8px;
`;

export const Causes = styled.div`
    display: flex;
    gap: 10px;
    margin-bottom: 15px;

    @media screen and (max-width: 767px){
        flex-direction: column;
    }
`;
export const CausesTitle = styled.h4`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size:18px;
    font-weight: 600;
    line-height:26px;
    margin-top: 7px;
`;

export const CausesList = styled.ul`
    display: flex;
    list-style: none;
    padding: 0;
    margin: 0;
    flex-wrap: wrap;
    gap: 10px;
`;

export const CausesItem = styled.li`
    background: #F2F2F2 0% 0% no-repeat padding-box;
    border-radius: 10px;
    font-family: "Jost", sans-serif;
    font-size: 18px;
    color: #333333;
    line-height: 30px;
    padding: 9px 14px;
    font-weight: 500;
    cursor: pointer;
       margin-bottom:5px;
     a{
     color: #333333;
         text-decoration: none;
      }  
`;

export const NonprofitDetails = styled.div`
    &.non-profit-details-text-two{
        margin-top: 20px;
    }
`;

export const TextHeading = styled.h5`
    font-family: "Jost", sans-serif;
    font-size: 18px;
    line-height: 26px;
    color: #333333;
    font-weight: 600;
    margin-bottom:5px;
`;

export const ContentCol = styled.p`
    color: #333333;
    font-family: "Jost", sans-serif;
    font-size: 18px;
    line-height: 27px;
    font-weight: 400;
    margin-bottom:15px;
    &.nepalcity{
        font-size: 14px;
        line-height: 21px;
    }
    &:last-child{
        margin-bottom:0px;
    }
`;

export const ContentColSpan = styled.span`
    color: #01606F;
    font-size: 18px;
    font-family: 'Jost', sans-serif;
    font-weight: 400;
    line-height: 26px;
`;

export const DonorVolunteerBoxWrap = styled.div`
    width: 100%;
    max-width: 894px;
    background: #33333329;
    border-radius: 15px;
    padding: 20px;
    margin-top: 20px;

    &.donor-volunteer-advisory-wrap{
        display: none;
    }
`;

export const DonorTextHeading = styled.h3`
    color: #333333;
    font-size: 20px;
    font-family: 'Jost', sand-serif;
    font-weight: 700;
    line-height: 30px;
    padding-left: 30px;
    margin-bottom: 15px;
    position: relative;

    &::before{
        content: '?';
        background: #01606F;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        color: #fff;
        font-size: 12px;
        font-family: 'Jost', sans-serif;
        font-weight: 400;
        line-height: 12px;
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 0;
        bottom: 0;
        left: 0;
        margin: auto;
        right: auto;
    }
`;